import {
  SDS_SPACE_2,
  SDS_SPACE_4,
  SDS_SPACE_8,
  SDS_SPACE_12,
  SDS_SPACE_16,
  SDS_SPACE_20,
  SDS_SPACE_24,
  SDS_SPACE_28,
  SDS_SPACE_32,
  SDS_SPACE_36,
  SDS_SPACE_48,
  SDS_SPACE_80,
} from '@s-group/design-system-tokens/web/tokens/space.es6'

export const SPACE_XXXXSMALL = SDS_SPACE_2
export const SPACE_XXXSMALL = SDS_SPACE_4
export const SPACE_XXSMALL = SDS_SPACE_8
export const SPACE_XSMALL = SDS_SPACE_12
export const SPACE_SMALL = SDS_SPACE_16
export const SPACE_MEDIUM = SDS_SPACE_20
export const SPACE_MEDIUM_PLUS = SDS_SPACE_24
export const SPACE_LARGE = SDS_SPACE_28
export const SPACE_LARGE_PLUS = SDS_SPACE_32
export const SPACE_XLARGE = SDS_SPACE_36
export const SPACE_XXLARGE = SDS_SPACE_48
export const SPACE_XXXXLARGE = SDS_SPACE_80
